import Footer from './Footer';
import FooterSimple from './FooterSimple';

export { FooterSimple };
export default Footer;
